export default "__VITE_ASSET__BzLy6DLD__"